import DOMPurify from "dompurify";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import EmptyData from "../../../components/EmptyData";

const TermsPublic = () => {
  const auth = useSelector((state) => state?.auth);
  const setting = useSelector((state) => state?.meta?.setting);

  const terms = auth?.isStaff ? setting?.staffTerms : setting?.terms;

  return (
    <>
      <SiteTitle title="قوانین و مقررات" />

      <div className="card basic-data-table">
        <div className="card-header p-0 border-0">
          <div className="responsive-padding-40-150 bg-light-pink">
            <div className="row gy-4 align-items-center">
              <div className="col-xl-7">
                <h6 className="mb-20">
                  شرایط و قوانین استفاده از سرویس‌ها و خدمات نت بوف
                </h6>
                <p className="mb-0 text-secondary-light max-w-634-px text-sm">
                  کاربر گرامی لطفاً موارد زیر را جهت استفاده بهینه از خدمات و
                  برنامه‌های کاربردی نت بوف به دقت ملاحظه فرمایید. ورود کاربران
                  به وب‌سایت نت بوف هنگام استفاده از پروفایل شخصی، طرح‌های
                  تشویقی، ویدئوهای رسانه تصویری نت بوف و سایر خدمات ارائه شده
                  توسط نت بوف به معنای آگاه بودن و پذیرفتن شرایط و قوانین و
                  همچنین نحوه استفاده از سرویس‌ها و خدمات نت بوف است. توجه داشته
                  باشید که ثبت سفارش نیز در هر زمان به معنی پذیرفتن کامل کلیه
                  شرایط و قوانین نت بوف از سوی کاربر است. لازم به ذکر است شرایط
                  و قوانین مندرج، جایگزین کلیه توافق‌های قبلی محسوب می‌شود.
                </p>
              </div>
              <div className="col-xl-5 d-xl-block d-none">
                <img src="/assets/images/faq-img.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="card-body bg-base responsive-padding-40-150">
          {isEmpty(terms) ? (
            <EmptyData title="قوانین و مقرراتی برای نمایش یافت نشد" />
          ) : (
            <div
              className="ql-editor"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(terms) }}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default TermsPublic;
